import { render, staticRenderFns } from "./BancoDeCartasTR.vue?vue&type=template&id=4e089b21"
import script from "./BancoDeCartasTR.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasTR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports